import React, { Component } from 'react'
import { connect } from 'react-redux'

import FormControl from '@material-ui/core/FormControl';
import {Link} from 'react-router-dom'
import * as actionsCreators from '../../store/actions/index'
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../http-config';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import Alert from '@material-ui/lab/Alert';
import InputAdornment from '@material-ui/core/InputAdornment';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import swal from 'sweetalert';
import moment from 'moment'
import { Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import Grid from '@material-ui/core/Grid';
import { DatePicker , MuiPickersUtilsProvider,KeyboardTimePicker,
    KeyboardDatePicker, KeyboardDateTimePicker} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withTranslation } from 'react-i18next';
const options=[
    {
        "id"  : 1,
        "key" : "Other"
    },
    {
        "id"  : 2,
        "key" : "Vacuum truck with tanker"
    },
    {
        "id"  : 3,
        "key" : "Tractor with tanker"
    },
    {
        "id"  : 4,
        "key" : "Truck with separate tank"
    }
]
const licensedWithULBOptions=[
    {
        "key"    : true,
        "name"   : "Yes"
    },
    {
        "key"    : false,
        "name"   : "No"
    }
]
const gpsInstalledOptions=[
    {
        "key"    : true,
        "name"   : "Yes"
    },
    {
        "key"    : false,
        "name"   : "No"
    }
]
const isDisableTruck=[
    {
        "key"   : false,
        "name"   : "Active"
    },
    {
        "key"    : true,
        "name"   : "In Active"
    }
]
class OperatorForm extends Component {
    constructor(props){
       super(props)
       this.state = {
        username            : this.props.username          ? this.props.username                 : "",
        password            :   "",   
        operatorId          : this.props.operatorId        ? this.props.operatorId               : "",
        id                  : this.props.id                ? this.props.id                       : "",
        operator            : this.props.name              ? this.props.name                     : "",
        ownerName           : this.props.applicantName     ? this.props.applicantName.trim()     : "",
        contactNo           : this.props.contactNumber     ? this.props.contactNumber.trim()     : "",
        email               : this.props.email             ? this.props.email                    : "",
        vehicleOwnerName    : this.props.vehicleOwnerName  ? this.props.vehicleOwnerName         : "",
        address             : this.props.addressOfOperator ? this.props.addressOfOperator.trim() : "",
        noOfTrucks          : this.props.noOfTrucks        ? this.props.noOfTrucks               : '',
        updatedDate         : this.props.updatedDate       ? this.props.updatedDate              : '',
        name_tn             : this.props.name_tn           ? this.props.name_tn                  : "",
        operatorErr         : '',
        ownerNameErr        : '',
        contactNoErr        : '',
        emailErr            : '',
        vehicleOwnerNameErr : '',
        addressErr          : '',
        usernameErr         : '',
        passwordErr         : '',
        isPasswordShown: false,
        isRePasswordShown:false,
        StatusValue         : !!this.props.isDisableOperator? !!this.props.isDisableOperator&&this.props.isDisableOperator  === 'Active' ?false :true:'',
        isStatus      : null,
        registrationNumber:'',
        registrationNumberErr:'',
        vehicleTypeId             : '',
        vehicleTypeIdErr          : '',
        capacity:'',
        capacityErr:'',
        isDisableTruck:'',
        licensedWithULB:'',
        licensedWithULBErr:'',
        ConfirmPassword:'',
        RepasswordError:'',
        RepasswordErr:'',
        selectedDate: moment(new Date()).format("yyyy"),
    }
    }
   
    handleChange = (event) =>{
        this.setState({[event.target.name]:event.target.value}
            , ()=> {
            this.checkValidity()
        }
        )
    }
    handleSubmit = (e) =>{
        const {t, i18n} = this.props
        const props = this.props
        e.preventDefault()
        const err = this.checkValidity()
        if(!err)
        {
            let props=this.props
            const formdata= {
                token            : this.props.token,
                id               : this.state.id,
                operator         : this.state.operator,
                name_tn          : this.state.name_tn,
                ownerName        : this.state.ownerName,
                contactNo        : this.state.contactNo,
                email            : this.state.email,
                vehicleOwnerName : this.state.vehicleOwnerName,
                noOfTrucks       : this.state.noOfTrucks,
                username         : this.state.username,
                password         : this.state.password,
                isDisableOperator : this.state.isStatus,
                capacity : this.state.capacity,
                vehicleNo:this.state.registrationNumber,
                gpsInstall : this.state.licensedWithULB,
                License: this.state.selectedDate,
                vehicleType : this.state.vehicleTypeId



            }
            // this.props.handleSubmit(formdata,props)
            this.props.onAddOperatorData(formdata, props, t)
            this.handleClose()
        }
    }
    checkValidity = () => {
        const {t, i18n} = this.props
        let isError = false

        if(!this.state.username){
            isError = true
            this.setState({
                usernameErr:`${t("required")}`
            })
        }
        else{
            isError = false
            this.setState({
                usernameErr:''
            })
        }
        if(this.state.username && !this.state.password){
            isError = true
            this.setState({
                passwordErr:`${t("required")}`,
               
            })
        }else{
            isError = false
            this.setState({
                passwordErr:''
            })  
        }
        // if(this.state.password && !this.state.username){
        //     isError = true
        //     this.setState({
        //         usernameErr:'*This field is required'
        //     })
        // }else{
        //     isError = false
        //     this.setState({
        //         usernameErr:''
        //     })  
        // }

        if(this.state.username && this.state.password){
            if(!this.state.password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
                isError = true
                this.setState({
                    passwordErr: `${t("ulbPassErr")}`
                })   
            }else{
                isError = false
                this.setState({
                    passwordErr:''
                })   
            }
        }


        if (this.state.password && !this.state.ConfirmPassword) {
            isError = false;
            this.setState({
                RepasswordErr:`${t("passMatch1")}`
            }) 
          }
         else if ( this.state.ConfirmPassword !== this.state.password &&  this.state.ConfirmPassword !== this.state.password) {
            isError = false;
            this.setState({
                RepasswordErr:`${t("passMatch2")}`
            }) 
          }else{
            isError = false
            this.setState({
                RepasswordErr:''
            })   
        }
        if(!this.state.operator){
            isError=true
            this.setState({operatorErr : `${t("required")}`})
        }
        // else if(!!this.state.operator&&this.state.operator.length > 0 && this.state.operator.length <3 ){
        //     isError=true
        //     this.setState({operatorErr : '*Name should be Minimum 3 characters and Maximum 100 characters'})
        // }
        else if(!!this.state.operator && this.state.operator.length>=3){
            isError = false
            this.setState({operatorErr:''})
        }
        else{
            if(!!this.state.operator&&this.state.operator.length > 0 && this.state.operator.length <3 ){
                isError=true
                this.setState({operatorErr : `${t('disposalLocalErr')}`})
            }
        }
        if(this.state.ownerName.length > 0 && this.state.ownerName.length <3){
            isError=true
            this.setState({ownerNameErr : `${t('disposalLocalErr')}`})
        }
        else{
            this.setState({ownerNameErr:''})
        }
        if(!this.state.contactNo){
            isError=true
            this.setState({contactNoErr:`${t("required")}`})
        }
        else if(this.state.contactNo){
            if(!this.state.contactNo.match(/^[0-9]{1,10}$/)){
                isError=true
                this.setState({contactNoErr:`${t("operatorContact")}`})
            }
            else{
                if(this.state.contactNo.length === 10){
                    isError=false
                    this.setState({contactNoErr:''})
                }
              
            }
     
        }else{
            this.setState({contactNoErr:''})
        }
        // else if(this.state.contactNo && this.state.contactNo.length>=10 && !Number.isNaN(parseInt(this.state.contactNo))) {
        //     this.setState({contactNoErr: ''})
        // }
        if(this.state.email){
            var mailformat= /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if(!this.state.email.match(mailformat)){
                isError=true
                this.setState({emailErr:`${t("ulbEmailErr")}`})
            }
            else{
                this.setState({emailErr:''})
            }
        }
        else if(!this.state.email){
            // isError=false
            this.setState({emailErr : ''})
        }
        // if(this.state.password && !this.props.operatorId){
        //     const passwordFormat = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/
        //     if(!this.state.password.match(passwordFormat)){
        //         isError=true
        //         this.setState({passwordErr:'*Password should be between 8 to 20 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character'})
        //     }else{
        //         isError = false
        //         this.setState({passwordErr : ''})
        //     }
        // }
        // if(!this.state.vehicleOwnerName){
        //     isError=true
        //     this.setState({vehicleOwnerNameErr:'*This field is required'})
        // }
        // else if(this.state.vehicleOwnerName.length>0 && this.state.vehicleOwnerName.length<3 ){
        //     isError=true
        //     this.setState({vehicleOwnerNameErr:"*Name should be Minimum 3 characters and Maximum 100 characters"})
        // }

        
        // else {
        //     this.setState({vehicleOwnerNameErr:''})
        // }


        if(!this.state.registrationNumber){
            isError=true
            this.setState({registrationNumberErr:`${t("required")}`})
        }
     
        else{
            this.setState({registrationNumberErr:''})
        }

        if(!this.state.vehicleTypeId){
            isError=true
            this.setState({vehicleTypeIdErr:`${t("required")}`})
        }
        else{
            this.setState({vehicleTypeIdErr:''})
        }

        if(!this.state.capacity){
            isError = true
            this.setState({capacityErr:`${t("required")}`})
        }
        else if(this.state.capacity && this.state.capacity< 10 || this.state.capacity > 20000 ){
            isError = true
            this.setState({capacityErr : "10 to 20,000"})
        }
        else if(this.state.capacity && this.state.capacity >= 10 || this.state.capacity <= 20000 ){
            this.setState({capacityErr:''})
        }
        return isError
    }
    toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
      ReToggleVisibility=()=>{
        const{isRePasswordShown}=this.state
        this.setState({isRePasswordShown:!isRePasswordShown})
      }
    //   handlChangeStatus = (e)=>{
    //     this.setState({isStatus: e.target.value , StatusValue :  e.target.value})
    //   }
      handleClose =()=>{
        this.props.handleClose(false)
        this.setState({
        emailErr         :'',
        contactNoErr     :'', 
        operatorErr      :'',
        passwordErr      :'', 
        usernameErr      :'',
        ConfirmPassword  :'',
        RepasswordErr     :'',
        username            :   "",
        password            :   "",   
        operatorId          :  "",
        operator            : "",
        ownerName           :"",
        contactNo           : "",
        email               :"",
        vehicleOwnerName    : "",
        address             :"",
        noOfTrucks          :  '',
        updatedDate         : '',
        name_tn             : "",
        registrationNumber:'',
        registrationNumberErr:'',
        vehicleTypeId             : '',
        vehicleTypeIdErr          : '',
        capacity:'',
        capacityErr:'',
        isDisableTruck:'',
        licensedWithULBErr:'',
        licensedWithULB:'',
        isPasswordShown:false,
        isRePasswordShown:false
     })
    }
    handleDateChange = (date) => {
        this.setState ({
          selectedDate:date
        })
      }
    render() {
        const {t, i18n} = this.props
        const operatorId = this.props.operatorId ? this.props.operatorId : ''
        return <div>
              <Dialog open={this.props.open} disableBackdropClick onClose={this.handleClose} aria-labelledby="form-dialog-title" maxWidth='md'>
                <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}> {t("addOpertor1")}</span></DialogTitle>
                <DialogContent>
                <div className="create_ulb_content_outer">
                 <div className="create_ulb_content create_ulb_contentPop">
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                        <FormControl>
                        <label className="required" htmlFor="operator">{t("operName")}</label>
                            <TextField id="operator" 
                                        variant="outlined" 
                                        placeholder={t("phoperName")}
                                        name="operator" 
                                        value={this.state.operator} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.operatorErr}</div>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                    
                        <FormControl>
                        <label htmlFor="name_tn">{t("operNameTel")}</label>
                            <TextField id="name_tn" 
                                        variant="outlined" 
                                        placeholder="ఆపరేటర్ పేరును నమోదు చేయండి" 
                                        name="name_tn" 
                                        value={this.state.name_tn} 
                                        onChange={this.handleChange}/>
                        
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    <FormControl>
                        <label htmlFor="ownerName">{t("operAppName")}</label>
                            <TextField id="ownerName" 
                                        variant="outlined" 
                                        placeholder={t("phoperAppName")} 
                                        name="ownerName" 
                                        value={this.state.ownerName} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.ownerNameErr}</div>
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    <FormControl>
                        <label className="required" htmlFor ="contactNo">{t("operContact")}</label>
                            <TextField id = "contactNo" 
                                        variant="outlined" 
                                        placeholder={t("phoperContact")} 
                                        name="contactNo" 
                                        value={this.state.contactNo} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.contactNoErr}</div>
                    </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                    <FormControl>
                    <label className="required" htmlFor ="VehicleNo">{t("operVehicle")}</label>
                    <TextField type="text"
                        id="registrationNumber"
                        variant="outlined"
                        size = "small"
                        placeholder ={t("phoperVehicle")}
                        value={this.state.registrationNumber}
                        name="registrationNumber"
                        onChange={this.handleChange}
                        InputProps={{ style: { fontSize: 12 } }}/>
                { this.state.registrationNumberErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.registrationNumberErr}</div> : <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required</div>}
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    <FormControl>
                        <label htmlFor = "email">{t("operEmail")}</label>
                            <TextField id = "email" 
                                        variant="outlined" 
                                        placeholder={t("phoperEmail")}
                                        name="email" 
                                        value={this.state.email} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.emailErr}</div>
                    </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                            <FormControl>
                            <label className="required" htmlFor ="VehicleNo">{t("operCapacity")}</label>
                            <TextField type="number"
                                id="capacity"
                                variant="outlined"
                                size = "small"
                                placeholder = {t("phoperCapacity")}
                                value={this.state.capacity}
                                name="capacity"
                                onChange={this.handleChange}
                                InputProps={{ style: { fontSize: 12, } }}/>
                    {this.state.capacityErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.capacityErr}</div> :  <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required</div>}
                            </FormControl>

                        </Grid>
                    <Grid item xs={6}>
                    <label className="required" htmlFor ="VehicleNo">{t("operVehicletype")}</label>
                    <FormControl variant="outlined" size="small">
                        <Select value={this.state.vehicleTypeId} 
                            onChange={this.handleChange} 
                            name="vehicleTypeId" 
                            size="small" 
                            style={{fontSize:12,width:'100%'}}>
                            {options.map((option) => (
                                <MenuItem key={option.id}
                                            style={{fontSize:12,width:'100%'}} 
                                            value={option.id}>
                                            {option.key}
                                </MenuItem>
                            ))}
                    </Select>
                        {this.state.vehicleTypeIdErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.vehicleTypeIdErr}</div> :  <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required</div>}
                        </FormControl>
                    </Grid>
                     
                    <Grid item xs={6}>
                        <label htmlFor ="VehicleNo">{t("operGPSIns")}</label>
                        <FormControl variant="outlined" size="small">
                                            <Select value={this.state.licensedWithULB} 
                                                    onChange={this.handleChange} 
                                                    name="licensedWithULB" 
                                                    size="small" 
                                                    style={{fontSize:12,width:'100%'}}>
                                                    {licensedWithULBOptions.map((option) => (
                                                        <MenuItem key={option.key}
                                                                  style={{fontSize:12,width:'100%'}} 
                                                                  value={option.key}>
                                                                  {option.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            {this.state.licensedWithULBErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%",}}>{this.state.licensedWithULBErr}</div> :<div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required </div> }
                                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                        <label htmlFor ="LicenseValidity">{t("operLicenseVal")}  </label>
                        <FormControl variant="outlined" size="small" className="style-input">
                        

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker
            format="yyyy"
            margin="normal"
            minDate={moment(new Date()).format('yyyy')}
            id="date-picker-inline"
            // label="Select Date"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
        />  
        </MuiPickersUtilsProvider>
      
                      
                        </FormControl>
                        </Grid>
                    
               
                    {/* <Grid item xs={6}>
                    <FormControl>
                        <label htmlFor = "address">Address of Applicant/Operator</label>
                            <TextField id = "address" 
                                        variant="outlined" 
                                        placeholder="Enter Address of Applicant/Operator" 
                                        name="address" 
                                        value={this.state.address} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.addressErr}</div>
                    </FormControl>
                    </Grid>  */}
                   {!this.state.operatorId && <Grid item xs={6}>
                    <FormControl>
                        <label className="required" htmlFor = "username">{t("operUserName")}</label>
                            <TextField id = "username" 
                                        variant="outlined" 
                                        placeholder={t("phoperUserName")} 
                                        name="username" 
                                        value={this.state.username} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.usernameErr}</div>
                    </FormControl>
                    </Grid>}
                    { !this.state.operatorId && <Grid item xs={6}>
                     <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("operPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("phoperPass")} 
                                      name="password" 
                                      value={this.state.password}
                                      onChange={this.handleChange}
                                      type={this.state.isPasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isPasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.toggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.toggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.passwordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                  </FormControl>
                  </form>
                    </Grid> }

                    <Grid item xs={6}>
                        {/* {
                            this.state.password !=""? */}
                            
                    <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("operConfirmPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("phoperConfirmPass")} 
                                      name="ConfirmPassword" 
                                      value={this.state.ConfirmPassword}
                                      onChange={this.handleChange}
                                      type={this.state.isRePasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isRePasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.ReToggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.ReToggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.RepasswordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.RepasswordErr}</div>
                  </FormControl>
                  </form> 
         
                    </Grid>

                    
                  
                  
                    </Grid>
                  
                 
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                        <div className="create_ulb_buttons">
                        <Button className="login_submit" variant="outlined" color="primary" onClick={this.handleClose }>{t("cancel")}</Button>
                        <Button className="login_submit" variant="contained" color="primary" onClick={this.handleSubmit}>{t("save")}</Button>
                    </div>
                        </Grid>
                    </Grid> 
                    </div>

                </div>
                </DialogContent>
                </Dialog>
                </div>
    
    }
}

const mapStateToProps = (state,props) => {
    
    return{
        props:props,
        token:state.auth.token
    }
}

const  mapDispatchToProps = dispatch=>{
    return{
        onAddOperatorData :(payload,props, t)=>dispatch(actionsCreators.addOperatorData(payload,props, t))
    }
   
}

export default connect(mapStateToProps,  mapDispatchToProps) (withTranslation()(OperatorForm))
